"use strict";

/** @namespace Fotobook */
(function(){

    var self = Fotobook;

    Object.assign(Fotobook, {
        main: "#main",
        mainPadding: {'x': 15, 'y': 10},

        isModified: false,
        resizeTimer: false,

        "urlParser": (function(){
            var parser = document.createElement("a");
            parser.display = "none";
            // !!!Баг ИЕ (всех версий)!!!
            // Если элемент a не подключен к DOM, он возвращает pathname без лидирующего слеша
            document.documentElement.appendChild(parser);
            return parser;
        })(),
        createStorageUrl(url) {
            if (!url) {
                console.warn('Empty URL path');
            }
            if (url && url.indexOf(Fotobook.config.data.storageUrl) !== 0) {
                url = Fotobook.config.data.storageUrl + url;
            }

            return url;
        },
        projectChecking: '<img src="/images/project-checking.gif" alt="" class="project-сhecking">',
        ajaxLoaderMin: '<img src="/images/circle-animation.gif" alt="Loading" class="ajax-loader-img ajax-loader-img-min">',
        isArray: jQuery.isArray,
        isFunction: jQuery.isFunction,
        debug(...params) {
            if (Fotobook.config.data.debug) {
                console.debug(...params);
            }
        },
        /**
         * Активен ли онлайн редактор ?
         *
         * @returns {boolean}
         */
        onlineEditorActive() {
            return Fotobook.store.state.OnlineEditor.active;
        },

        /** темплейт фото на время загрузки оригинала */
        noOriginalTmpl() {
            const imageUrl = ['/images/error.png', Fotobook.config.data.buildTime].join('?');
            return `<div class="no-original-block booklet-remove">
                    ${Fotobook.noOriginalTmplSvg()}
                    <div class="no-original-image">
                        <img src="${imageUrl}" alt="No original" class="no-original-img">
                   </div>
                </div>
                ${Fotobook.ajaxLoaderMin}`;
        },

        /** */
        noOriginalTmplSvg: function (cls) {
            cls = cls || "";
            return [
                '<svg class="' + cls + '" height="100%" width="100%" x="0" y="0">',
                    '<rect x="0" y="0" width="100%" height="100%" fill="url(#no-original-pattern)" mask="url(#no-original-mask)" />',
                '</svg>'
            ].join("");
        },

        fileReaderFilter: /^(?:image\/jpeg|image\/png)$/i,

        // Application AJAX methods END
        checkParents: function (element, attr) {
            if (!element.length) {
                return false;
            }
            var el = null;
            $.each(element.parents(), function () {
                if ($(this).hasClass('redactor-editor')) {
                    return false;
                } else if ($(this).inlineStyle(attr)) {
                    el = $(this);
                    return false;
                }
            });
            return el;
        },

        /**
         * Изменить размер текста ("Drop your photo here") в масштабируемом пустом контейнере
         *
         * @param {int } fontSize
         */
        textFitToParent: function (fontSize) {
            var $this = $(this),
                $ph = $this.find(".text-fit-to-parent"), // контейнер с текстом
                len, size, parent_k, w, h, lh;

            if (!$ph.length) {
                return;
            }

            fontSize = fontSize || Fotobook.book.BASE_SIZE;
            len = $ph.text().length;
            size = $this.computedSize();
            // непосредственно получаем clientHeight элемента, а не css атрибут.
            lh = parseFloat($ph[0].clientHeight) / parseFloat($ph.css("font-size")),
                w = .8 * size.width;                    // 80% - максимальный размер текста. Мб стоит сделать настраиваемым?
            h = .8 * size.height;
            parent_k = w / h;
            if (parent_k > 2.3) {
                fontSize = Math.min(w / len * 1.8, h / lh);
            } else if (parent_k > 1.3) {
                fontSize = Math.min(w / len * 2.4, h / lh / 2);
            } else {
                fontSize = Math.min(w / len * 3.5, h / lh / 3);
            }

            $ph.css({
                "font-size": fontSize,
                "display": "",
            });
        },

        /**
         * Инициализация редактора
         * @todo: разнести обработчики данных по своим местам
         */
        async init(initData) {
            const self = this;
            const checkProjectAfterLoad = Fotobook.$cookies.get('checkProjectAfterLoad');

            $(document).triggerHandler(Fotobook.events.ONLINE_EDITOR_INIT_DATA, [initData]);
            self.setEditModeClasses(initData.edit_mode);

            $(window).resize(function (event) {
                if (this != event.target && event.target != document) {
                    event.preventDefault();
                    return false;
                }
                $(document).triggerHandler(Fotobook.events.EDITOR_RESIZE, event);
                clearTimeout(self.resizeTimer);
                self.resizeTimer = setTimeout(function(){
                    Fotobook.bottomPanel.carousel.create();
                }, 300);
            });

            Fotobook.book.initState(initData);
            if (checkProjectAfterLoad === 'true') {
                Fotobook.$cookies.remove('checkProjectAfterLoad');
                $('html').addClass('display-book-errors');

                await Fotobook.store.dispatch('bottomPanel/toggle');
                // Fotobook.bottomPanel.togglePanel();

                self.pages.selectBadPage();
            }
            if (Fotobook.$cookies.get('isModified')) {
                Fotobook.$cookies.remove('isModified');
                self.isModified = true;
            }

            if (window.location.hash === '#preview') {
                $(document).triggerHandler(Fotobook.events.COMMANDS_LOCK);
                Fotobook.commands.togglePreview();
            }

            /**
             * Обработчик на закрытие окна редактора
             */
            Fotobook.beforeUnload.addCondition(self.mustConfirmBeforeLeavePage);

            $(window).on("unload", () => {
                this.unload();
            });

            $(document).triggerHandler(Fotobook.events.ONLINE_EDITOR_STARTED, [initData]);
        },

        /**
         * Изменение свойств проекта
         * @param event
         * @param response
         */
        modified: (event, response) => {
            self.isModified = true;

            if (response && response.data.state) {
                Fotobook.book.initState(response.data);
            }
        },

        forwardUrl(url){
            Fotobook.beforeUnload.clearStack();
            Fotobook.logEvent.info("PhotoBook.log.message.editor.exit", [Fotobook.book.project.name]).finally(() => {
                window.location.replace(url);
            }).catch(()=>null);
        },

        leaveGuestDialog(){
            return Fotobook.dialog.confirm('<div>' + t("photobook-js-leaveEditorText") + '</div>', {
                "title": t("photobook-js-guestLeaveEditorDialogTitle") + "?",
                "width": 360,
                "modal": true,
                "height": "auto",
                "resizable": false,
                "showButtonCancel" : true,
                "closeButtonAction" : "none",
                "create": function(){
                    $(".ui-state-focus").removeClass("ui-state-focus");
                },
            });
        },
        leaveUserDialog(){
            return Fotobook.dialog.confirm(t('photobook-js-saveProjectQuestion'), {
                "title": t("photobook-js-leaveEditorDialogTitle"),
                "showButtonCancel" : true,
                "rejected" : !this.isModified,
                "closeButtonAction" : "none",
                "fotobookDialogClass" : "autotest-leave-editor-dialog",
            })
        },
        /**
         * Диалог выхода из онлайн-редактора
         */
        leaveDialog: function(){
            return Fotobook.store.state.user.id ? this.leaveUserDialog() : this.leaveGuestDialog();
        },

        /**
         * Действие обрабатываемое в случае ухода из редактора
         * @param event
         */
        leave(event){
            event.preventDefault();
            const url = $(event.target).closest("[href]").attr("href");
            setTimeout(() => {
                this.showLeaveDialog(() => this.forwardUrl(url));
            }, 0);
        },

        /**
         * Показывает предупреждение об уходе со страницы с последующим действием, которое передается извне.
         *
         * @param {function} cb действие после подтверждения юзера
         */
        showLeaveDialog(cb) {
            const dialog = this.leaveDialog();

            dialog.catch(() => {
                cb();
            });
            dialog.then(() => this.saveProject())
                .then(() => Fotobook.login.loginIfGuest())
                .then(() => {
                    cb();
                })
                .catch(() => {});
        },

        unload() {
            if (self.isModified) {
                Fotobook.$cookies.set('isModified', true, '30d');
            }
        },

        /** Изменение размера рабочей области редактора */
        resize(){
            self.resizeWorkspace($("#book:visible,#book-preview:visible"));
        },

        /** Пересчет размеров области книги/предпросмотра в редакторе */
        resizeWorkspace: function ($book) {
            if (!$book.length) {
                return;
            }

            var $html = $(document.documentElement),
                preview = $html.hasClass("preview"),
                $wrap = $book.closest(".main-wrapper"),
                wrapJsp = $wrap.data("jsp")
            ;

            if (wrapJsp) {
                // var bbox = $book[0].getBoundingClientRect(),
                //     bbox2 = $wrap.find(".book-page-num")[0].getBoundingClientRect(),
                //     height = Math.abs(Math.min(bbox.top, bbox2.top) - Math.max(bbox.bottom, bbox2.bottom)) * 1.1; // todo 1.1 - что за число???
                //
                // $wrap.css("line-height", height > $wrap.height() ? height + "px" : $wrap.css("height"));
                Fotobook.substrate.recalculateWithZoom();
                wrapJsp.reinitialise();
            } else {
                Fotobook.substrate.resize($book);
            }

            if (!preview){
                Fotobook.book.fitEmptyFotoText();
            }
            Fotobook.book.recalcAllElements();
        },

        filterEmptyPages: function($pages){
            return $pages.filter(function(idx, e){
                return parseInt(e.getAttribute("data-id"), 10) >= 0;
            });
        },

        checkValidPage: function(pages){
            if (!pages.length || pages.length != pages.filter(".page").length) {
                Fotobook.notification.showWarning(t("photobook-js-messagePageLayoutForPages"));
                return false;
            }
            return true;
        },

        /**
         * Сообщение о повторном использовании фото
         *
         * @param id
         */
        warnIfAlreadyUsed: function(id){
            if (id && $(Fotobook.book.pagesList).find(".foto-image.foto_" + id).length > 0) {
                Fotobook.notification.showWarning(t("photobook-js-messagePhotoAlreadyMapped"));
            }
        },

        /** Сохранение проекта */
        saveProject(asyncPreview=true){
            const promise = new Promise((resolve, reject) => {
                const $dialog = Fotobook.dialog.alert(t("photobook-js-savingProject") + ": " + Fotobook.projectChecking, {
                    "title": t("photobook-js-saving") + '...',
                    "width": 400,
                    "showButtonResolve" : false,
                });

                Fotobook.core.saveProject(asyncPreview).then((response) => {
                    return Fotobook.dialog.alert(response.data.additional_message, {
                        "title": t("photobook-js-saveProjectDialogTitle"),
                        "width": 400,
                        "buttonResolve": t("photobook-js-buttonsClose"),
                        "fotobookDialogClass": "autotest-save-dialog",
                        "closeButtonAction" : "resolve",
                        "resolved": !response.data.additional_message || !response.data.additional_message.length,
                    });
                })
                .then(resolve)
                .catch(reject)
                .finally(() => {
                    Fotobook.dialog.close($dialog);
                });
            });

            // убрать отсюда
            promise.catch(() => {}).finally(() => $(document).triggerHandler(Fotobook.events.COMMANDS_UNLOCK));

            return promise;
        },

        /**
         * Условие проверки при закрытии окна редактора
         *
         * @returns {boolean}
         */
        mustConfirmBeforeLeavePage: function () {
            return (
                Fotobook.onlineEditorActive()
                && self.isModified
            );
        },

        getAlbumById: function(id){
            for (var idx in Fotobook.book.albums) {
                if (Fotobook.book.albums[idx].id == id) {
                    return Fotobook.book.albums[idx];
                }
            }
        },

        /**
         * Пренадлежит ли текущий альбом проекту
         *
         * @returns {Boolean}
         */
        isCurrentAlbum: function(){
            var album = this.getAlbumById($("#albums").val());
            return album && album.project_id == Fotobook.book.project.id;
        },

        getMarkedAlbum: function(){
            var album_id = $("#albums .marked-album").attr("value");

            return this.getAlbumById(album_id);
        },

        setEditModeClasses: function(mode){
            var $html = $("html"),
                classes = ($html.attr("class") || "").split(" ");
            for (var i = 0, l = classes.length; i < l; i++) {
                if (classes[i].indexOf("edit-mode-") === 0) {
                    $html.removeClass(classes[i]);
                }
            }

            $(".low-quality-mark").attr("data-qtip-selector", "photobook-tooltipText-low-quality-" + mode.code);
            $html.addClass("edit-mode-" + mode.code);
            Fotobook.store.commit('OnlineEditor/setEditMode', mode.code);
        },

        /** Изменить режим редактора  */
        changeEditMode(id) {
            const promise = Fotobook.ajax.post('/editor/change-edit-mode', {
                data: {
                    id,
                },
            }).then((response) => {
                self.setEditModeClasses(response.data.edit_mode);
                $(document).trigger(Fotobook.events.SWITCH_EDIT_MODE);
                return response;
            });
            promise.catch(() => null);
            return promise;
        },

        /**
         * Переключение отображения книги в редакторе - одностраничный/многостраничный режим
         *
         * @param single_page_mode
         */
        changeSinglePageMode(single_page_mode) {
            if (Fotobook.book.single_page_mode === single_page_mode) {
                return;
            }

            let pages = Fotobook.book.getSortedPagesArray(),
                spine = $(Fotobook.book.pagesList).find(".spine-outer"),
                chunks, content;

            Fotobook.book.single_page_mode = single_page_mode;
            $("html").toggleClass("single-page-mode", Fotobook.book.single_page_mode);

            chunks = Fotobook.book.fillPageChunks(pages, single_page_mode);
            content = Fotobook.book.drawCarouselItems(chunks, true);
            Fotobook.book.replacePagesCarousel(content);
            Fotobook.book.appendSpine(spine);

            Fotobook.bottomPanel.carousel.create();
            Fotobook.book.drawCurrent();
        },

        /**
         * Заментиь в имени фото small_square (фото для панели превью) на square (фото для редактора/предпросмотра)
         *
         * @param path
         * @returns {string}
         */
        replaceSmallImagePath: function(path){
            return path ? path.replace(/small_/g, "") : "";
        },
    });


    $(document)
    // todo функционал, связанный с переходом из редактора на другую страницу, нужно пересмотреть
    .on("click", ".layout-wizard .site_logo, .header .leaveable.leave a:not(.disabled)", (event) => Fotobook.leave(event))
    .on(Fotobook.events.MODIFIED, self.modified)
    .on(Fotobook.events.EDITOR_RESIZE, self.resize)
    ;

})();
